//前端图片的连接地址，发布生产时需要修改
// const devUrl ='http://172.18.21.221:8090/flexbase/attachment/image?fid=id&chksum=chksum';
//本地
// const url = 'http://172.18.21.221:8090/flexbase/attachment/image';
// const url = '/api/vi/portal/picture/getPicture';
//现场
const url = 'flexbase/attachment/image';
//现场附件下载
// const fileUrl = 'http://10.249.172.9:8081/flexbase/attachment/download';
const fileUrl = 'http://172.18.21.221:8090/flexbase/attachment/download';
export const imgUrl = {
  path: url
};
export const downloadFileUrl = {
  path: fileUrl
};
export const menus = {
  xwzxMenuList: [
    { menuName: "新闻时讯", menuUrl: "/xwzx/tzyw", menuCode: 'SYZT_XWZX_TZYW' },
    { menuName: "本院新闻", menuUrl: "/xwzx/syxw", menuCode: 'SYZT_XWZX_SYXW' },
    { menuName: "市县新闻", menuUrl: "/xwzx/sxxw", menuCode: 'SYZT_XWZX_SXXW' },
    { menuName: "公示公告", menuUrl: "/xwzx/tzgg", menuCode: 'SYZT_XWZX_TZGG' },
  ],
  xygkMenuList: [
    { menuName: "学院简介", menuUrl: "/xygk/xyjj", menuCode: 'SYZT_XYGK_XYJJ' },
    { menuName: "社院历史", menuUrl: "/xygk/syls", menuCode: 'SYZT_XYGK_SYLS' },
    { menuName: "现任领导", menuUrl: "/xygk/xrld", menuCode: 'SYZT_XYGK_XRLD' },
    { menuName: "学院风光", menuUrl: "/xygk/xyfg", menuCode: 'SYZT_XYGK_XYFG' },
    { menuName: "地理位置", menuUrl: "/xygk/dlwz", menuCode: 'SYZT_XYGK_DLWZ' },
  ],
  jxpxMenuList: [
    { menuName: "教学培训", menuUrl: "/jxpx/jxxx", menuCode: 'SYZT_JXPX_JXXX' },
    { menuName: "教学研究", menuUrl: "/jxpx/jxyj", menuCode: 'SYZT_JXPX_JXYJ' },
    { menuName: "专职教师", menuUrl: "/jxpx/zzjs", menuCode: 'SYZT_JXPX_ZZJS' },
    { menuName: "兼职教师", menuUrl: "/jxpx/jzjs", menuCode: 'SYZT_JXPX_JZJS' },
    { menuName: "教务管理", menuUrl: "/jxpx/jwgl", menuCode: 'SYZT_JXPX_JWGL' },
    { menuName: "对外培训", menuUrl: "/jxpx/dwpx", menuCode: 'SYZT_JXPX_DWPX' }
  ],
  kyzkMenuList: [
    { menuName: "科研动态", menuUrl: "/kyzk/kydt", menuCode: 'SYZT_KYZK_KYDT' },
    { menuName: "科研管理", menuUrl: "/kyzk/kygl", menuCode: 'SYZT_KYZK_KYGL' },
    { menuName: "科研成果", menuUrl: "/kyzk/kycg", menuCode: 'SYZT_KYZK_KYCG' },
  ],
  tzllMenuList: [
    { menuName: "经典论述", menuUrl: "/tzll/jdls", menuCode: 'SYZT_TZLL_JDLS' },
    { menuName: "统战政策", menuUrl: "/tzll/tzzc", menuCode: 'SYZT_TZLL_TZZC' },
    { menuName: "统战文选", menuUrl: "/tzll/tzwx", menuCode: 'SYZT_TZLL_TZWX' },
  ],
  whjlMenuList: [
    { menuName: "学院简介", menuUrl: "/whjl/xyjj", menuCode: 'SYZT_WHJL_XYJJ' },
    { menuName: "学院动态", menuUrl: "/whjl/xydt", menuCode: 'SYZT_WHJL_XYDT' },
    { menuName: "浙江文化", menuUrl: "/whjl/zjwh", menuCode: 'SYZT_WHJL_ZJWH' },
    { menuName: "中华文化", menuUrl: "/whjl/zhwh", menuCode: 'SYZT_WHJL_ZHWH' },
  ],
  ztMenuList: [
    { menuName: "专题01", menuUrl: "/zt/zt01", menuCode: 'SYZT_ZT01' },
    { menuName: "专题02", menuUrl: "/zt/zt02", menuCode: 'SYZT_ZT02' },
    { menuName: "专题03", menuUrl: "/zt/zt03", menuCode: 'SYZT_ZT03' },
    { menuName: "专题04", menuUrl: "/zt/zt04", menuCode: 'SYZT_ZT04' },
  ],
  jgdjMenuList: [
    {menuName: "党建新闻", menuUrl: "/jgdj/djxw", menuCode: 'SYZT_JGDJ_DJXW'}
  ],
  yjsMenuList: [
    {menuName: "预计决算信息", menuUrl: "/yjs/yjsxx", menuCode: 'yjsxxgk'}
  ],
   tsgMenuList: [
    { menuName: "本院概况", menuUrl: "/tsg/bygk", menuCode: 'SYZT_TSG_BYGK' },
    { menuName: "数字资源", menuUrl: "/tsg/szzy", menuCode: 'SYZT_TSG_SZZY' },
    { menuName: "图书检索", menuUrl: "/tsg/tsjs", menuCode: 'SYZT_TSG_TSJS' },
  ],
    czdzxMenuList: [
    { menuName: "中心概况", menuUrl: "/czdzx/zxgk", menuCode: 'SYZT_CZDJSYJZX_ZXGK' },
    { menuName: "中心信息", menuUrl: "/czdzx/zxxx", menuCode: 'SYZT_CZDJSYJZX_ZXXX' },
    { menuName: "参政党研究文献", menuUrl: "/czdzx/czdwx", menuCode: 'SYZT_CZDJSYJZX_CZDWX' },
    { menuName: "其他研究资料", menuUrl: "/czdzx/yjzl", menuCode: 'SYZT_CZDJSYJZX_YJZL' },
    { menuName: "案例库", menuUrl: "/czdzx/ajk", menuCode: 'SYZT_CZDJSYJZX_ALK' },
  ],
     fgyzjjzxMenuList: [
    { menuName: "中心概况", menuUrl: "/fgyzjjzx/zxgk", menuCode: 'SYZT_FGYZJJZX_ZXGK' },
    { menuName: "中心信息", menuUrl: "/fgyzjjzx/zxxx", menuCode: 'SYZT_FGYZJJZX_ZXXX' },
    { menuName: "研究资料", menuUrl: "/fgyzjjzx/yjzl", menuCode: 'SYZT_FGYZJJZX_YJZL' },
    { menuName: "案例库", menuUrl: "/fgyzjjzx/ajk", menuCode: 'SYZT_FGYZJJZX_ALK' },
  ],
     mzyzjzxMenuList: [
    { menuName: "中心概况", menuUrl: "/mzyzjzx/zxgk", menuCode: 'SYZT_MZYZJYJZX_ZXGK' },
    { menuName: "中心信息", menuUrl: "/mzyzjzx/zxxx", menuCode: 'SYZT_MZYZJYJZX_ZXXX' },
    { menuName: "研究资料", menuUrl: "/mzyzjzx/yjzl", menuCode: 'SYZT_MZYZJYJZX_YJZL' },
    { menuName: "案例库", menuUrl: "/mzyzjzx/ajk", menuCode: 'SYZT_MZYZJYJZX_ALK' },
  ],
     zhwhzxMenuList: [
    { menuName: "中心概况", menuUrl: "/zhwhzx/zxgk", menuCode: 'SYZT_ZHWHYJZX_ZXGK' },
    { menuName: "中心信息", menuUrl: "/zhwhzx/zxxx", menuCode: 'SYZT_ZHWHYJZX_ZXXX' },
    { menuName: "研究资料", menuUrl: "/zhwhzx/yjzl", menuCode: 'SYZT_ZHWHYJZX_YJZL' },
    { menuName: "案例库", menuUrl: "/zhwhzx/ajk", menuCode: 'SYZT_ZHWHYJZX_ALK' },
  ],
  yjdtMenuList:[
    {
      menuName:"参政党建设研究中心",
      menuUrl:"/yjdt/czdjsyjzx",
      menuCode: 'SYZT_CZDJSYJZX',
      children:[
        { menuName: "中心概况", menuUrl: "/yjdt/czdjsyjzx/zxgk", menuCode: 'SYZT_CZDJSYJZX_ZXGK' },
        { menuName: "中心信息", menuUrl: "/yjdt/czdjsyjzx/zxxx", menuCode: 'SYZT_CZDJSYJZX_ZXXX' },
        { menuName: "参政党研究文献", menuUrl: "/yjdt/czdjsyjzx/czdyjwx", menuCode: 'SYZT_CZDJSYJZX_CZDWX' },
        { menuName: "其他研究资料", menuUrl: "/yjdt/czdjsyjzx/qtyjzl", menuCode: 'SYZT_CZDJSYJZX_YJZL' },
        { menuName: "案例库", menuUrl: "/yjdt/czdjsyjzx/alk", menuCode: 'SYZT_CZDJSYJZX_ALK' },
      ]
    },{
      menuName:"非公有制经济两个健康研究中心",
      menuUrl:"/yjdt/fgyzjjlgjkyjzx",
      menuCode: 'SYZT_FGJJLGJKYJZX',
      children:[
        { menuName: "中心概况", menuUrl: "/yjdt/fgyzjjzx/zxgk", menuCode: 'SYZT_FGYZJJZX_ZXGK' },
        { menuName: "中心信息", menuUrl: "/yjdt/fgyzjjzx/zxxx", menuCode: 'SYZT_FGYZJJZX_ZXXX' },
        { menuName: "研究资料", menuUrl: "/yjdt/fgyzjjzx/yjzl", menuCode: 'SYZT_FGYZJJZX_YJZL' },
        { menuName: "案例库", menuUrl: "/yjdt/fgyzjjzx/ajk", menuCode: 'SYZT_FGYZJJZX_ALK' },
      ]
    },{
      menuName:"民族与宗教研究中心",
      menuUrl:"/yjdt/mzyzjyjzx",
      menuCode: 'SYZT_MZYZJYJZX',
      children:[
        { menuName: "中心概况", menuUrl: "/yjdt/mzyzjzx/zxgk", menuCode: 'SYZT_MZYZJYJZX_ZXGK' },
        { menuName: "中心信息", menuUrl: "/yjdt/mzyzjzx/zxxx", menuCode: 'SYZT_MZYZJYJZX_ZXXX' },
        { menuName: "研究资料", menuUrl: "/yjdt/mzyzjzx/yjzl", menuCode: 'SYZT_MZYZJYJZX_YJZL' },
        { menuName: "案例库", menuUrl: "/yjdt/mzyzjzx/ajk", menuCode: 'SYZT_MZYZJYJZX_ALK' },
      ]
    },{
      menuName:"中华文化研究中心",
      menuUrl:"/yjdt/zhwhyjzx",
      menuCode: 'SYZT_ZHWHYJZX',
      children:[
        { menuName: "中心概况", menuUrl: "/yjdt/zhwhzx/zxgk", menuCode: 'SYZT_ZHWHYJZX_ZXGK' },
        { menuName: "中心信息", menuUrl: "/yjdt/zhwhzx/zxxx", menuCode: 'SYZT_ZHWHYJZX_ZXXX' },
        { menuName: "研究资料", menuUrl: "/yjdt/zhwhzx/yjzl", menuCode: 'SYZT_ZHWHYJZX_YJZL' },
        { menuName: "案例库", menuUrl: "/yjdt/zhwhzx/ajk", menuCode: 'SYZT_ZHWHYJZX_ALK' },
      ]
    }
  ]
};



// WEBPACK FOOTER //
// ./src/package/api.js